import { areRecordsEqual } from '@cascade/core/utils';
import type { TIdentity } from './observability.types.ts';

export const areIdentitiesEqual = (
  left?: TIdentity,
  right?: TIdentity,
): boolean => {
  if (!left || !right) {
    return left === right;
  }

  return (
    left.userId === right.userId &&
    areRecordsEqual(left.traits ?? {}, right.traits ?? {})
  );
};
